import type { LucideIcon } from "lucide-react";
import {
	Banknote,
	Car,
	GraduationCap,
	Home,
	Plane,
	Sunset,
	Wrench,
} from "lucide-react";
import {
	GoalCategoryTypeEnum,
	GoalCoveredStateEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

type GoalCategoryConfig = {
	icon: LucideIcon;
	color: string;
	bgColor: string;
};

export const SELECTABLE_GOAL_CATEGORIES: GoalCategoryTypeEnum[] = [
	GoalCategoryTypeEnum.House,
	GoalCategoryTypeEnum.Car,
	GoalCategoryTypeEnum.Pension,
	GoalCategoryTypeEnum.Rent,
	GoalCategoryTypeEnum.Student,
	GoalCategoryTypeEnum.Vacation,
	GoalCategoryTypeEnum.Basic,
];

export const EXAMPLE_GOAL_CATEGORIES = [
	GoalCategoryTypeEnum.Pension,
	GoalCategoryTypeEnum.House,
] as const;

export type ExampleGoalCategory = (typeof EXAMPLE_GOAL_CATEGORIES)[number];

export const GOAL_CATEGORY_CONFIG: Record<
	GoalCategoryTypeEnum,
	GoalCategoryConfig
> = {
	[GoalCategoryTypeEnum.House]: {
		icon: Home,
		color: "#3B82F6",
		bgColor: "#DBEAFE",
	},
	[GoalCategoryTypeEnum.Car]: {
		icon: Car,
		color: "#16A34A",
		bgColor: "#DCFCE7",
	},
	[GoalCategoryTypeEnum.Pension]: {
		icon: Sunset,
		color: "#EA580C",
		bgColor: "#FFEDD5",
	},
	[GoalCategoryTypeEnum.Student]: {
		icon: GraduationCap,
		color: "#7C3AED",
		bgColor: "#EDE9FE",
	},
	[GoalCategoryTypeEnum.Basic]: {
		icon: Wrench,
		color: "#6B7280",
		bgColor: "#F3F4F6",
	},
	[GoalCategoryTypeEnum.Vacation]: {
		icon: Plane,
		color: "#0284C7",
		bgColor: "#E0F2FE",
	},
	[GoalCategoryTypeEnum.Rent]: {
		icon: Banknote,
		color: "#D97706",
		bgColor: "#FEF3C7",
	},
};

export type Goal = {
	id: string;
	name: string;
	category: GoalCategoryTypeEnum;
	status: GoalCoveredStateEnum | null;
	totalValue: number;
	coveredAmount: number;
	dueIn: string;
	completed?: boolean;
};

export type StatusStyle = { color: string; progressColor: string };

export const STATUS_LABEL_MAP: Record<
	GoalCoveredStateEnum,
	typeof Resources.Goals.List.Status.onTrack
> = {
	[GoalCoveredStateEnum.OnTrack]: Resources.Goals.List.Status.onTrack,
	[GoalCoveredStateEnum.Warning]: Resources.Goals.List.Status.warning,
	[GoalCoveredStateEnum.OffTrack]: Resources.Goals.List.Status.offTrack,
	[GoalCoveredStateEnum.Unplanned]: Resources.Goals.List.Status.unplanned,
};
